/**
 * Sibling Product Seamless Transition Handler
 * Enables instant, zero-flicker transitions between sibling products
 * (e.g. Fabrix Pro <-> Fabrix Steam) while preserving the exact scroll position.
 */
(function() {
  'use strict';

  if (window.__siblingTransitionInit) return;
  window.__siblingTransitionInit = true;

  let isTransitioning = false;

  async function smoothProductTransition(targetUrl, clickedEl) {
    if (!targetUrl || isTransitioning) return;

    try {
      const currentUrlObj = new URL(window.location.href);
      const targetUrlObj = new URL(targetUrl, window.location.origin);

      // Do nothing if already on the target product page
      if (currentUrlObj.pathname === targetUrlObj.pathname) {
        return;
      }

      isTransitioning = true;

      // 1. Instant tactile feedback: toggle active state on clicked card
      if (clickedEl) {
        const link = clickedEl.closest('a') || clickedEl;
        const container = link.closest('ul.swatches') || link.closest('.set-cards') || link.closest('.variant-input-wrapper') || link.parentElement;
        if (container) {
          container.querySelectorAll('input[type="radio"]').forEach(inp => inp.checked = false);
          container.querySelectorAll('.set-card').forEach(c => c.classList.remove('is-active'));
          const inp = link.querySelector('input[type="radio"]');
          if (inp) inp.checked = true;
          const card = link.querySelector('.set-card') || link;
          card.classList.add('is-active');
        }
      }

      // 2. Lock current scroll position
      const savedScrollY = window.scrollY;

      // 3. Subtle smooth opacity transition on MainContent
      const mainContent = document.getElementById('MainContent');
      if (mainContent) {
        mainContent.classList.add('is-transitioning');
      }

      // 4. Fetch the target product page in the background
      const response = await fetch(targetUrlObj.href);
      if (!response.ok) {
        window.location.href = targetUrlObj.href;
        return;
      }

      const responseText = await response.text();
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(responseText, 'text/html');
      const newMain = newDoc.getElementById('MainContent');

      if (!newMain || !mainContent) {
        window.location.href = targetUrlObj.href;
        return;
      }

      // 5. Update browser history & page title
      window.history.pushState({ url: targetUrlObj.href, scrollY: savedScrollY }, '', targetUrlObj.href);
      if (newDoc.title) {
        document.title = newDoc.title;
      }

      // 6. Swap MainContent DOM
      mainContent.innerHTML = newMain.innerHTML;

      // 7. Execute scripts inside new MainContent (innerHTML does not execute them by default)
      const scripts = Array.from(mainContent.querySelectorAll('script'));
      for (const oldScript of scripts) {
        // Skip JSON or LD+JSON scripts
        const type = (oldScript.getAttribute('type') || '').toLowerCase();
        if (type.includes('json')) continue;

        const newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach(attr => {
          newScript.setAttribute(attr.name, attr.value);
        });
        if (oldScript.src) {
          newScript.src = oldScript.src;
        } else {
          newScript.textContent = oldScript.textContent;
        }
        oldScript.parentNode.replaceChild(newScript, oldScript);
      }

      // 8. Freeze scroll position at exact click position
      window.scrollTo({ top: savedScrollY, behavior: 'instant' });

      // 9. Dispatch theme events for re-initialization
      document.dispatchEvent(new CustomEvent('page:loaded'));
      document.dispatchEvent(new CustomEvent('shopify:section:load'));

    } catch (error) {
      console.error('[SiblingTransition] Error during seamless transition:', error);
      window.location.href = targetUrl;
    } finally {
      const mainContent = document.getElementById('MainContent');
      if (mainContent) {
        mainContent.classList.remove('is-transitioning');
      }
      isTransitioning = false;
    }
  }

  window.smoothProductTransition = smoothProductTransition;

  // Intercept click on any set-card or sibling link
  document.addEventListener('click', function(event) {
    const link = event.target.closest('a[data-product-url], .set-card[data-product-url], a.set-card, [data-sibling-link]');
    if (!link) return;

    const url = link.getAttribute('data-product-url') || link.getAttribute('href');
    if (!url || url === '#' || url.startsWith('javascript:')) return;

    // Check if clicked card is already active
    const card = link.querySelector('.set-card') || link;
    const radio = link.querySelector('input[type="radio"]');
    if ((radio && radio.checked) || card.classList.contains('is-active')) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    smoothProductTransition(url, card);
  }, true);

  // Handle browser back and forward buttons smoothly
  window.addEventListener('popstate', function(event) {
    if (event.state && event.state.url) {
      smoothProductTransition(event.state.url);
    } else {
      window.location.reload();
    }
  });

})();
